import { io, Socket } from 'socket.io-client'

import { getAdminSocketUrl } from 'handlers/getAdminSocketUrl'

/**
 * Создаёт сокет админских заказов.
 * @param token — значение localStorage `token` (с Bearer)
 */
export const createAdminOrdersSocket = (token: string): Socket => {
  return io(getAdminSocketUrl(), {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 2000,
  })
}
